module.exports = __webpack_public_path__ + "img/22800.116ef987.jpg";